import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { RemoveRedEye } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "components/Button/Button";
import { Input } from "components/Form";
import ModalBox from "components/modal/ModalBox";
import parse from "html-react-parser";
import TextEditor from "components/TextEditor/TextEditor";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Badge, Fab } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";



import {
  objectTypeChecker,
  rawToHtmlConverter,
  wrapImagesWithFigure,
} from "utils";
import Switch from "components/Switch/Switch";
import {
  addGSChapter,
  editGSChapter,
  getGSChapterById,
  getGSChaptersList,
  updateChapterDisplayorder,
  updateStatusGSChapter,
} from "services/gsfreeresources";
import { ContentState, convertFromHTML, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import Link from "components/Button/Link";
import { getPostbyId, getPostCommentsList, getPostList, updateDisplayWebsiteStatus, updatePostComment, updatePostCommentReplyStatus, updatePostCommentStatus, updatePostDisplayorder, updatePostStatus } from "services/blogs/blogs";
import { Badge as BSBadge } from "react-bootstrap";
import { Avatar } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import LikesBadge from "components/ImageLoader/LikeHeart";




export default function GSPostListComments() {
  const { postid, posttitle } = useParams();
  const [record, setRecord] = useState([{}]);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [displaywebsiteModal, setdisplaywebsiteModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [repliesModal, setRepliesModal] = useState(false);
  const [selectedReplies, setSelectedReplies] = useState([]);
  const [selectedReplyIds, setSelectedReplyIds] = useState([]);



  const [data, setData] = useState({
    // question: EditorState.createEmpty(),
    // explaination: EditorState.createEmpty(),
  });
  const [errorField, setErrorField] = useState({});

  const [viewModal, setViewModal] = useState(false);
  const [shortdescriptionModal, setshortdescriptionModal] = useState(false);
  const [Shortdescription, setshortdescription] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [categoryModal, setcategoryModal] = useState(false);
  const [approveModal, setapproveModal] = useState(false);
  const [categories, setcategories] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [selectedId, setSelectId] = useState("");
  const usertypeid = localStorage.getItem("roleid")
  console.log("usertypeid", usertypeid);


  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [editedDisplayOrder, setEditedDisplayOrder] = useState({});
  const inputRef = useRef(null);
  const [shouldFocusInput, setShouldFocusInput] = useState(true);

  // ***************************************** Fetch Records ********************************************************
  const fetchRecords = async () => {
    showLoader();
    try {
      const res = await getPostCommentsList({
        page: activePage,
        search: search,
        limit: limit,
        postid: postid
      });
      hideLoader();
      if (res.code === 200) {
        const { count, rows } = res.data.PostComments;
        setRecord(rows || []);
        setTotal(count || 0);
      } else {
        setRecord([]);
        setTotal(0);
        // toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    fetchRecords();
  }, [search, activePage, limit]);

  const handleApproveComment = async (status) => {
    try {
      const res = await updatePostCommentStatus({
        postid: postid,
        commentid: selectedId,
        status: status
      });
      if (res.code == 200) {
        setData({});
        setSelectId("");
        setapproveModal(false);
        fetchRecords();
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      toast.error("Failed to Update Status Of Subject");
    }
  };
  const handleApproveCommentReplies = async (status) => {
    try {
      if (selectedReplyIds.length === 0) {
        toast.warning("Please select at least one reply to approve");
        return;
      }
      console.log("status", status);

      const res = await updatePostCommentReplyStatus({
        postid: postid,
        commentid: selectedId,
        replyids: selectedReplyIds,
        status: status
      });
      console.log("res", res);

      if (res.code == 200) {
        setData({});
        setSelectId("");
        setRepliesModal(false);
        setSelectedReplyIds([]);
        setSelectId("");
        fetchRecords();
        toast.success(res.message);
      } else {
        toast.error(res.message);
        setRepliesModal(false);
        setSelectedReplyIds([]);
        setSelectId("");
      }
    } catch (e) {
      toast.error("Failed to Update Status");
      setRepliesModal(false);
      setSelectedReplyIds([]);
      setSelectId("");
    }
  };


  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap">
                <div className="SearchBox mt-1">
                  {/* <div style={{ marginRight: "10px" }}>
                    <Input
                      className={"form-control"}
                      placeholder="Search Here"
                      value={search}
                      onChange={({ target }) => setSearch(target.value)}
                      type="text"
                    />
                  </div> */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* <div>
                      <Button
                        to="add-post"
                        type="acl"
                        role={450006}
                      >
                        Create Post
                      </Button>
                    </div> */}
                  </div>
                </div>
              </div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                {posttitle} Comments
              </h4>
            </div>



            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Comment</th>
                    <th style={{ textAlign: "center" }}>Likes</th>
                    <th style={{ textAlign: "center" }}>Replies</th>
                    <th style={{ textAlign: "center" }}>Status</th>

                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          name,
                          email,
                          comment,
                          likes,
                          approved,
                          sectionid,
                          replyCount,
                          replies,
                          status,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td style={{ width: "20px" }}>
                            {++i + (activePage - 1) * limit}
                          </td>



                          <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                            {name}
                          </td>
                          <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                            {email}
                          </td>
                          <td style={{ maxWidth: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                            {comment}
                          </td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <LikesBadge likes={likes} />
                            </div>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <Badge
                                color="error"
                                badgeContent={replyCount}
                                showZero
                              >
                                <ChatIcon
                                  style={{ color: "#1976d2", cursor: "pointer" }}
                                  onClick={() => {
                                    setSelectedReplies(replies || []);
                                    setRepliesModal(true);
                                    setSelectId(id);
                                  }}
                                />

                              </Badge>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <IconButton aria-label="pending" className="px-1 py-0" onClick={() => {
                                setSelectId(id);
                                setapproveModal(true);
                              }}>
                                <EditIcon sx={{ color: "#4971B2" }} />
                              </IconButton>

                              {approved == true && (
                                <IconButton aria-label="approved" className="px-1 py-0" disabled>
                                  <TaskAltIcon sx={{ color: "green" }} />
                                </IconButton>
                              )}
                            </div>
                          </td>

                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>
              </Table>
            </div>
            {total >= 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={(e) => setActivePage(e)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <ModalBox
        custom={true}
        status={repliesModal}
        onClose={() => setRepliesModal(false)}
        size={"md"}
        title={"Replies"}
        customizedFooter={
          <>
            <Button onClick={() => handleApproveCommentReplies(1)}>
              Approve
            </Button>
            <Button onClick={() => handleApproveCommentReplies(0)}>
              Disapprove
            </Button>

            <Button
              className="mx-2"
              onClick={() => {
                setRepliesModal(false);
                setSelectId("");
              }}
            >
              Cancel
            </Button>
          </>
        }

      >
        <div className="table-responsive">
          <Table bordered className="table">
            <thead style={{ fontWeight: "600", fontSize: "12px", textTransform: "uppercase", padding: "7px 10px", backgroundColor: "#d6e6ff" }}>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    style={{ width: "17px", height: "17px", cursor: "pointer" }}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedReplyIds(selectedReplies.map((r) => r.id));
                        console.log("selectedReplyIds", selectedReplies);
                      } else {
                        setSelectedReplyIds([]);
                      }
                    }}
                    checked={
                      selectedReplies.length > 0 &&
                      selectedReplyIds.length === selectedReplies.length
                    }
                  />
                </th>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Reply</th>
                <th>Likes</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody style={{ fontSize: "14px" }}>
              {selectedReplies.length > 0 ? (
                selectedReplies.map((reply, i) => (
                  <tr key={reply.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedReplyIds.includes(reply.id)}
                        style={{ width: "17px", height: "17px", cursor: "pointer" }}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedReplyIds([...selectedReplyIds, reply.id]);
                            console.log("selectedReplyIds", selectedReplyIds);

                          } else {
                            setSelectedReplyIds(
                              selectedReplyIds.filter((id) => id !== reply.id)
                            );
                          }
                        }}
                      />
                    </td>
                    <td>{i + 1}</td>
                    <td>{reply.name}</td>
                    <td>{reply.email}</td>
                    <td>{reply.comment}</td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <LikesBadge likes={reply.likes} />
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center">
                        {reply.approved == true && (
                          <IconButton aria-label="approved" className="px-1 py-0" disabled>
                            <TaskAltIcon sx={{ color: "green" }} />
                          </IconButton>
                        )}
                        {reply.approved == false && (
                          <IconButton aria-label="approved" className="px-1 py-0" disabled>
                            <HourglassEmptyIcon sx={{ color: "rgb(58 119 192)" }} />
                          </IconButton>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">No replies found</td>
                </tr>
              )}
            </tbody>

          </Table>
        </div>
      </ModalBox>



      <ModalBox
        custom={true}
        status={approveModal}
        onClose={() => setapproveModal(false)}
        size={"sm"}
        title={"Update Comment Status"}
        description={"Are you sure you want to change the status?"}
        customizedFooter={
          <>
            <Button onClick={() => handleApproveComment(1)}>
              Approve
            </Button>
            <Button onClick={() => handleApproveComment(0)}>
              Disapprove
            </Button>

            <Button
              className="mx-2"
              onClick={() => {
                setapproveModal(false);
                setSelectedReplyIds([]);
                setSelectId("");
              }}
            >
              Cancel
            </Button>
          </>
        }
      // custom={false}
      // Close={true}
      />



    </>
  );
}
